// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__1GERk","card":"styles_card__1TyJG"};